import { AsLeftFireTestSectionDataM71 } from './Data/M71/M71.data';

export const selectAsLeftFireTestSectionData = (selectedTag, formName, formData) => {
    let filterViewData = { rows: [] };
    if (formName === 'M7-1') {
        filterViewData = AsLeftFireTestSectionDataM71(formData);
    }
    return filterViewData;
};
